import cleanCss from 'helpers/cleanCss';
import getViewPort from 'helpers/getViewPort';
import sortStyles from 'helpers/sortStyles';
import loadSingleFont from 'helpers/loadSingleFont';

export default function setCssMediaQuery(thatStyle, typeOfStyle, viewPort, thisWindow) {

  if (typeof thatStyle === 'string') {
    console.log('CSS should not be string - please debug/fix asap and remove this console.log');
  }

  if (!thatStyle || typeof thatStyle !== 'object') return ''; 

  let thisCss = '';
  const thisStyles = thatStyle[typeOfStyle];
  const thisStylesHover = thatStyle[`${typeOfStyle}_hover`];

  if (!thatStyle) return thisCss;

  const setViewPort = getViewPort(viewPort);

  const sortedStyles = sortStyles(thisStyles, !viewPort);

  const sortedStylesHover = sortStyles(thisStylesHover, !viewPort);

  if (sortedStyles) {
    for (let i = 0; i < sortedStyles.length; i++) {
   
      const contentKey = sortedStyles[i].replace('_', '.');

      const contentValue = thisStyles[sortedStyles[i]];
      if (contentValue && contentValue['font-family']) {
        const thisFont = contentValue['font-family'];
        const fontName = thisFont.substring(0, thisFont.indexOf(','));

        const thisLoadedFont = loadSingleFont(fontName ? fontName : thisFont, null, thisWindow);
        if (!sortedStyles['font-weight'] && thisLoadedFont) {
          thisCss += `
            font-weight: ${thisLoadedFont};     
          `;
        }
      }
      if (setViewPort && (Number(setViewPort) <= Number(contentKey) && setViewPort !== '0') || contentKey === '0') {
        thisCss += `
          ${cleanCss(contentValue)}
        `;
      }
      if (!setViewPort && contentKey !== '0') {

        thisCss += `
          @media (max-width: ${contentKey}em) {
            ${cleanCss(contentValue)}
          }
        `;
      }

    }

  }

  if (sortedStylesHover) {

    for (let i = 0; i < sortedStylesHover.length; i++) {

      const contentKey = sortedStylesHover[i].replace('_', '.');

      const contentValue = thisStylesHover[sortedStylesHover[i]];
      let extraStyles = '';
      if (contentValue && contentValue['font-family']) {
        const thisFont = contentValue['font-family'];
        const fontName = thisFont.substring(0, thisFont.indexOf(','));

        const thisLoadedFont = loadSingleFont(fontName ? fontName : thisFont, null, thisWindow);
        if (!sortedStyles['font-weight'] && thisLoadedFont) {
          extraStyles += `
              font-weight: ${thisLoadedFont};      
          `;
        }
      }

      if (setViewPort && (Number(setViewPort) <= Number(contentKey) && setViewPort !== '0') || contentKey === '0') {
        thisCss += `
          &:hover {
            ${extraStyles}
            ${cleanCss(contentValue)}
          }
        `;
      }

      if (!setViewPort && contentKey !== '0') {
        thisCss += `
          @media (max-width: ${contentKey}em) {
            &:hover {
              ${extraStyles}
              ${cleanCss(contentValue)}
            }
          }
        `;
      }

    }
  }

  return thisCss.replace(/\s\s+/g, ' ');
}
